import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-218" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-219" data-mp="2bfbx90bkndf1">
        <SectionTag icon="⚡" data-id="element-220" data-mp="2bh6g893a8vgh">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-221" data-mp="26nbpilp9fg7w">
          Tus preparaciones no deben ser así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-222" data-mp="2z4edc3qk4y7f">
          Un domingo por la noche, buscando ejercicios sueltos en Pinterest que no sabes si van a funcionar
          el martes con tus alumnos. Dudando si está bien alineado con LOMLOE. Preguntándote cómo adaptarte
          al alumno con dificultad.
        </p>

        <div className="mt-6 rounded-2xl border border-flash/20 bg-flash/5 p-5 text-left sm:p-6" data-id="element-223" data-mp="1a6rgg5rhil35">
          <p className="font-heading text-sm font-bold uppercase tracking-wide text-flash" data-id="element-224" data-mp="wfcvhte0o9tg">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-225" data-mp="mhonw2vbb7tv">
            <span className="font-semibold text-ink" data-id="element-226" data-mp="mjrpzl9qorey">El costo real:</span> Planificar manualmente te quita
            de <span className="rounded-sm bg-yellow px-1 font-semibold text-navy" data-id="element-227" data-mp="ref4qsexy7gc">4 a 7 horas por semana</span>.
            Es el equivalente a más de un mes entero de trabajo al año quemado en búsquedas, dudas sobre
            LOMLOE y preparaciones que no funcionan.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-228" data-mp="2bwmrfv0op2z6">
        <div className="space-y-4" data-id="element-229" data-mp="2bw394d74gckm">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-slate-200 bg-bg-secondary p-5 sm:p-6" data-id="element-230" data-mp="3kucu9tp66k0v" data-mpi={i}>
              <p className="mb-3 text-xs font-bold uppercase tracking-wider text-muted" data-id="element-231" data-mp="7enjw8fuuxhz">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-232" data-mp="3e4suglsdvgu">
                <div className="flex items-start gap-3" data-id="element-233" data-mp="3urr77jbvwqof">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/10" data-id="element-234" data-mp="3uq6fs2kv9nus">
                    <XIcon size={14} className="text-danger" data-id="element-235" data-mp="3pqtsjgq32ero" />
                  </div>
                  <div data-id="element-236" data-mp="r4qy604ep1n5">
                    <p className="text-xs font-bold uppercase tracking-wide text-danger" data-id="element-237" data-mp="mbxu7egrhxc4">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-238" data-mp="tn2gssdu6xz3">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-239" data-mp="yn8asf7kwwkc">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/10" data-id="element-240" data-mp="13l9tgz13etva">
                    <CheckIcon size={14} className="text-success" data-id="element-241" data-mp="17nd8tyqvuilu" />
                  </div>
                  <div data-id="element-242" data-mp="1cm82jvqe1rkq">
                    <p className="text-xs font-bold uppercase tracking-wide text-success" data-id="element-243" data-mp="1ckwydut16ht3">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-ink" data-id="element-244" data-mp="1hjzrqhznezl8">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-245" data-mp="1r9t0zccbj2mb">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-246" data-mp="1rcnl12rf6lf7">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-247" data-mp="20b9alhvb70ph">
          <ScrollHintTable minWidth="480px" data-id="element-248" data-mp="20caodu3pm1aw">
            <div className="grid grid-cols-3 divide-x divide-slate-200 bg-bg-secondary" data-id="element-249" data-mp="2096gomr1cnfh">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-250" data-mp="1im5hpb8r3t7n">
                  <span className="font-heading text-xl font-bold text-flash sm:text-2xl" data-id="element-251" data-mp="1wdaf06onc9et">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-252" data-mp="1rg248r5tv7nl">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}